.addElementDropdown {
  display: none;
  position: absolute;
  left: 3em;
  padding: 0.1em;
  width: 300px;
  box-shadow: 0 0 1em var(--lightGray);
  border: var(--lightGray) solid 1px;
  background-color: var(--white);

  &.open {
    z-index: 1;
    display: block;
  }

  & li:hover {
    background-color: var(--silver);
  }

  & button {
    color: var(--black);
    margin: 0;
    padding: 0.5em 1em;
    width: 100%;
    text-align: start;
    border: 0;
    background: transparent;
  }
}
